import AssistancePage from "./pages/assistance/AssistancePage";
import AdminAssistancePage from "./pages/assistance/AdminAssistancePage";
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import "./App.css";
import "./custom.css";
import "./index.css";

/* ================= LAYOUT ================= */
import MainLayout from "./components/MainLayout";

/* 🎁 ANIMATION CADEAU (GLOBAL) */
import GiftAnimation from "./components/GiftAnimation";

/* ================= PUBLIC ================= */
import Home from "./pages/Home";
import Feed from "./pages/Feed";
import TikTokFeed from "./pages/TikTokFeed";
import Login from "./pages/Login";
import Register from "./pages/Register";
import UploadVideoPage from "./pages/UploadVideoPage";
import UploadGalleryPage from "./pages/UploadGalleryPage";
import MessagesPage from "./pages/MessagesPage";
import Conversation from "./pages/Conversation";
import UserProfile from "./pages/UserProfile";
import LivePage from "./pages/LivePage";
import VideoById from "./pages/VideoById";
import VideoPage from "./pages/VideoPage";
import CoffreDashboard from "./pages/CoffreDashboard";
import CoinsBalance from "./pages/CoinsBalance";
import CoinsTransactions from "./pages/CoinsTransactions";
import CadeauxRecusPage from "./pages/CadeauxRecusPage";
import GiftPage from "./pages/GiftPage";
import PacksPage from "./pages/PacksPage";
import VideoStudio from "./pages/VideoStudio";
import UploadTabs from "./pages/tabs/UploadTabs";
import SoldePage from "./pages/SoldePage";
import FriendsPage from "./pages/FriendsPage";
import WithdrawCoinsConfirm from "./pages/WithdrawCoinsConfirm";
import WithdrawEurosConfirm from "./pages/WithdrawEurosConfirm";
import WithdrawEuros from "./pages/retrait/WithdrawEuros";
import LivesShowPage from "./pages/LivesShowPage";
import VideoShortsPage from "./pages/VideoShortsPage";
import CoinsShowPage from "./pages/CoinsShowPage";
import SecurityShowPage from "./pages/SecurityShowPage";
import LiveChatDemoPage from "./pages/LiveChatDemoPage";
import LiveFluidDemoPage from "./pages/LiveFluidDemoPage";
import LiveGiftsDemoPage from "./pages/LiveGiftsDemoPage";
import LiveModerationDemoPage from "./pages/LiveModerationDemoPage";
import VideoCreateDemoPage from "./pages/VideoCreateDemoPage";
import VideoMobileDemoPage from "./pages/VideoMobileDemoPage";
import VideoEffectsDemoPage from "./pages/VideoEffectsDemoPage";
import StoriesDemoPage from "./pages/StoriesDemoPage";
import DecouverteDemoPage from "./pages/DecouverteDemoPage";
import GiftsDemoPage from "./pages/GiftsDemoPage";
import CreatorSupportDemoPage from "./pages/CreatorSupportDemoPage";
import EarningsDemoPage from "./pages/EarningsDemoPage";
import PaiementsEncadresDemoPage from "./pages/PaiementsEncadresDemoPage";
import CoinPacksDemoPage from "./pages/CoinPacksDemoPage";
import PaymentsDemoPage from "./pages/PaymentsDemoPage";
import AntiSpamDemoPage from "./pages/AntiSpamDemoPage";
import ModerationDemoPage from "./pages/ModerationDemoPage";
import DataProtectionDemoPage from "./pages/DataProtectionDemoPage";
import CommunityRulesDemoPage from "./pages/CommunityRulesDemoPage";

/* ✅ PAGES VITRINE */
import PrivacyPolicy from "./pages/PrivacyPolicy";
import LegalNotice from "./pages/LegalNotice";
import ContactPage from "./pages/ContactPage";

/* ✅ NOUVEAU STUDIO EVO */
import CreatePage from "./pages/CreatePage";

import MusicPage from "./pages/music/MusicPage";

/* ================= STORY ================= */
import StoryCreatePage from "./pages/StoryCreatePage";

/* ================= SAFE ================= */
import Safe from "./pages/Safe";

/* ================= STAFF WEB ================= */
import StaffDashboardPage from "./pages/staff/StaffDashboardPage";
import StaffStreamAlertPage from "./pages/staff/StaffStreamAlertPage";
import StaffLoginPage from "./pages/staff/StaffLoginPage";
import StaffAgenciesPage from "./pages/staff/StaffAgenciesPage";
import StaffComingSoonPage from "./pages/staff/StaffComingSoonPage";
import StaffSupportTicketsPage from "./pages/staff/StaffSupportTicketsPage";
import StaffSpecialRequestsPage from "./pages/staff/StaffSpecialRequestsPage";
import StaffQuickRepliesPage from "./pages/staff/StaffQuickRepliesPage";
import StaffReportedVideosPage from "./pages/staff/StaffReportedVideosPage";
import StaffMessageReportsPage from "./pages/staff/StaffMessageReportsPage";
import StaffUserReportsPage from "./pages/staff/StaffUserReportsPage";
import StaffVideoPendingPage from "./pages/staff/StaffVideoPendingPage";
import StaffBlockedCommentsPage from "./pages/staff/StaffBlockedCommentsPage";
import StaffSpamBotsPage from "./pages/staff/StaffSpamBotsPage";
import StaffUsersBannedPage from "./pages/staff/StaffUsersBannedPage";

/* ================= AUDIO ================= */
import { AudioProvider } from "./audio/AudioContext";
import MiniPlayer from "./components/MiniPlayer";

/* ================= ADMIN WEB ================= */
import AdminPanelWebPage from "./pages/admin/AdminPanelWebPage";
import AdminAgenciesPage from "./pages/admin/AdminAgenciesPage";
import AdminReportsWebPage from "./pages/admin/AdminReportsWebPage";
import AdminCertificationPage from "./pages/admin/AdminCertificationPage";
import AdminUsersWebPage from "./pages/admin/AdminUsersWebPage";
import AdminStatsWebPage from "./pages/admin/AdminStatsWebPage";
import AdminToolsWebPage from "./pages/admin/AdminToolsWebPage";
import AdminGiftsPanel from "./pages/admin/AdminGiftsPanel";
import AdminStaffWebPage from "./pages/admin/AdminStaffWebPage";
import AdminStaffActivityPage from "./pages/admin/AdminStaffActivityPage";
import StaffLivesActivePage from "./pages/staff/StaffLivesActivePage";
import StaffLiveCasesPage from "./pages/staff/StaffLiveCasesPage";
import AdminPacksWebPage from "./pages/admin/AdminPacksWebPage";
import AdminMusicWebPage from "./pages/admin/AdminMusicWebPage";
import AdminMusicValidationPage from "./pages/admin/AdminMusicValidationPage";
import AdminNotificationsWebPage from "./pages/admin/AdminNotificationsWebPage";
import AdminGainsWebPage from "./pages/admin/AdminGainsWebPage";
import AdminWithdrawalsWebPage from "./pages/admin/AdminWithdrawalsWebPage";
import AdminAdminsPage from "./pages/admin/AdminAdminsPage";
import AdminVideoList from "./pages/admin/AdminVideoList";
import AdminTransactionsPanel from "./pages/admin/AdminTransactionsPanel";

/* ✅ RETRAIT */
import Retrait from "./pages/Retrait";
import RetraitCadeaux from "./pages/retrait/RetraitCadeaux";

function App() {
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  const accessToken = localStorage.getItem("evoAccessToken");
  const isLogged = !!currentUser && !!accessToken;

  const ADMIN_EMAILS = [
    "admin.live.evo@gmail.com"
  ];

  const STAFF_EMAILS = [
    "admin-test@live-evo.com"
  ];

  const isAdmin =
    currentUser?.is_admin === 1 ||
    currentUser?.is_admin === true ||
    ADMIN_EMAILS.includes(currentUser?.email);

  const isStaff =
    currentUser?.role === "staff" ||
    currentUser?.is_staff === 1 ||
    currentUser?.is_staff === true ||
    STAFF_EMAILS.includes(currentUser?.email);

  const canAccessStaff = isAdmin || isStaff;

  return (
    <AudioProvider>
      <Router>
        <Routes>

          {/* ================= STORY CREATE ================= */}
          <Route
            path="/story/create"
            element={
              isLogged ? <StoryCreatePage /> : <Navigate to="/login" replace />
            }
          />

          {/* ================= PAGES VITRINE SANS MENU / SANS NAVBAR ================= */}
          <Route path="/confidentialite" element={<PrivacyPolicy />} />
          <Route path="/mentions-legales" element={<LegalNotice />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/assistance" element={<AssistancePage />} />

          {/* ================= STAFF WEB SANS MENU / SANS FOOTER ================= */}
          <Route
            path="/staff"
            element={
              !isLogged ? (
                <StaffLoginPage />
              ) : !canAccessStaff ? (
                <Navigate to="/staff" replace />
              ) : (
                <StaffDashboardPage />
              )
            }
          />

          <Route
            path="/staff/agencies"
            element={
              !isLogged ? (
                <Navigate to="/login" replace />
              ) : !canAccessStaff ? (
                <Navigate to="/safe" replace />
              ) : (
                <StaffAgenciesPage />
              )
            }
          />

          <Route
            path="/staff/support"
            element={
              !isLogged ? (
                <Navigate to="/login" replace />
              ) : !canAccessStaff ? (
                <Navigate to="/safe" replace />
              ) : (
                <StaffSupportTicketsPage />
              )
            }
          />

          <Route
            path="/staff/requests"
            element={
              !isLogged ? (
                <Navigate to="/login" replace />
              ) : !canAccessStaff ? (
                <Navigate to="/safe" replace />
              ) : (
                <StaffSpecialRequestsPage />
              )
            }
          />

          <Route
            path="/staff/replies"
            element={
              !isLogged ? (
                <Navigate to="/login" replace />
              ) : !canAccessStaff ? (
                <Navigate to="/safe" replace />
              ) : (
                <StaffQuickRepliesPage />
              )
            }
          />

          <Route
            path="/staff/reported-videos"
            element={
              !isLogged ? (
                <Navigate to="/login" replace />
              ) : !canAccessStaff ? (
                <Navigate to="/safe" replace />
              ) : (
                <StaffReportedVideosPage />
              )
            }
          />

          <Route
            path="/staff/message-reports"
            element={
              !isLogged ? (
                <Navigate to="/login" replace />
              ) : !canAccessStaff ? (
                <Navigate to="/safe" replace />
              ) : (
                <StaffMessageReportsPage />
              )
            }
          />

          <Route
            path="/staff/user-reports"
            element={
              !isLogged ? (
                <Navigate to="/login" replace />
              ) : !canAccessStaff ? (
                <Navigate to="/safe" replace />
              ) : (
                <StaffUserReportsPage />
              )
            }
          />

          <Route
            path="/staff/video-pending"
            element={
              !isLogged ? (
                <Navigate to="/login" replace />
              ) : !canAccessStaff ? (
                <Navigate to="/safe" replace />
              ) : (
                <StaffVideoPendingPage />
              )
            }
          />

          <Route
            path="/staff/blocked-comments"
            element={
              !isLogged ? (
                <Navigate to="/login" replace />
              ) : !canAccessStaff ? (
                <Navigate to="/safe" replace />
              ) : (
                <StaffBlockedCommentsPage />
              )
            }
          />

          <Route
            path="/staff/spam-bots"
            element={
              !isLogged ? (
                <Navigate to="/login" replace />
              ) : !canAccessStaff ? (
                <Navigate to="/safe" replace />
              ) : (
                <StaffSpamBotsPage />
              )
            }
          />

          <Route
            path="/staff/users-banned"
            element={
              !isLogged ? (
                <Navigate to="/login" replace />
              ) : !canAccessStaff ? (
                <Navigate to="/safe" replace />
              ) : (
                <StaffUsersBannedPage />
              )
            }
          />

          <Route path="/staff/live-reports" element={isLogged && canAccessStaff ? <StaffLiveCasesPage kind="reports" /> : <Navigate to="/login" replace />} />
          <Route path="/staff/live-chat-reports" element={isLogged && canAccessStaff ? <StaffLiveCasesPage kind="chat" /> : <Navigate to="/login" replace />} />
          <Route path="/staff/music-reports" element={isLogged && canAccessStaff ? <StaffComingSoonPage /> : <Navigate to="/login" replace />} />
          <Route path="/staff/suspicious-accounts" element={isLogged && canAccessStaff ? <StaffComingSoonPage /> : <Navigate to="/login" replace />} />
          <Route path="/staff/security" element={isLogged && canAccessStaff ? <StaffComingSoonPage /> : <Navigate to="/login" replace />} />
          <Route path="/staff/lives-active" element={isLogged && canAccessStaff ? <StaffLivesActivePage /> : <Navigate to="/login" replace />} />
          <Route path="/staff/live-risk" element={isLogged && canAccessStaff ? <StaffComingSoonPage /> : <Navigate to="/login" replace />} />
          <Route path="/staff/stream-alert" element={isLogged && canAccessStaff ? <StaffStreamAlertPage /> : <Navigate to="/login" replace />} />
          <Route path="/staff/live-history" element={isLogged && canAccessStaff ? <StaffComingSoonPage /> : <Navigate to="/login" replace />} />

          {/* ================= ADMIN WEB SANS MENU / SANS FOOTER ================= */}
          <Route
            path="/admin/*"
            element={
              !isLogged ? (
                <Navigate to="/login" replace />
              ) : !isAdmin ? (
                <Navigate to="/safe" replace />
              ) : (
                <Routes>
                  <Route index element={<AdminPanelWebPage />} />
                  <Route path="staff-activity" element={<AdminStaffActivityPage />} />
                  <Route path="assistance" element={<AdminAssistancePage />} />
                  <Route path="live-reports" element={<StaffLiveCasesPage kind="reports" />} />
                  <Route path="reports" element={<AdminReportsWebPage />} />
                  <Route path="users" element={<AdminUsersWebPage />} />
                  <Route path="agencies" element={<AdminAgenciesPage />} />
                  <Route path="stats" element={<AdminStatsWebPage />} />
                  <Route path="tools" element={<AdminToolsWebPage />} />
                  <Route path="gifts" element={<AdminGiftsPanel />} />
                  <Route path="staff" element={<AdminStaffWebPage />} />
                  <Route path="certification" element={<AdminCertificationPage />} />
                  <Route path="coin-packs" element={<AdminPacksWebPage />} />
                  <Route path="music" element={<AdminMusicWebPage />} />
                  <Route path="music-validation" element={<AdminMusicValidationPage />} />
                  <Route path="notifications" element={<AdminNotificationsWebPage />} />
                  <Route path="gains" element={<AdminGainsWebPage />} />
                  <Route path="transactions" element={<AdminTransactionsPanel />} />
                  <Route path="admins" element={<AdminAdminsPage />} />
                  <Route path="videos" element={<AdminVideoList />} />
                  <Route path="*" element={<AdminPanelWebPage />} />
                  <Route path="withdrawals" element={<AdminWithdrawalsWebPage />} />
                </Routes>
              )
            }
          />

          {/* ================= ROUTES DEMO PLEIN ÉCRAN ================= */}
          <Route path="/video-mobile-demo" element={<VideoMobileDemoPage />} />
          <Route path="/video-effects-demo" element={<VideoEffectsDemoPage />} />
          <Route path="/video-create-demo" element={<VideoCreateDemoPage />} />
          <Route path="/live-moderation-demo" element={<LiveModerationDemoPage />} />
          <Route path="/live-gifts-demo" element={<LiveGiftsDemoPage />} />
          <Route path="/live-fluid-demo" element={<LiveFluidDemoPage />} />
          <Route path="/live-chat-demo" element={<LiveChatDemoPage />} />
          <Route path="/stories-demo" element={<StoriesDemoPage />} />
          <Route path="/decouverte-demo" element={<DecouverteDemoPage />} />
          <Route path="/gifts-demo" element={<GiftsDemoPage />} />
          <Route path="/creator-support-demo" element={<CreatorSupportDemoPage />} />
          <Route path="/earnings-demo" element={<EarningsDemoPage />} />
          <Route path="/paiements-encadres-demo" element={<PaiementsEncadresDemoPage />} />
          <Route path="/coin-packs-demo" element={<CoinPacksDemoPage />} />
          <Route path="/payments-demo" element={<PaymentsDemoPage />} />
          <Route path="/anti-spam-demo" element={<AntiSpamDemoPage />} />
          <Route path="/moderation-demo" element={<ModerationDemoPage />} />
          <Route path="/data-protection-demo" element={<DataProtectionDemoPage />} />
          <Route path="/community-rules-demo" element={<CommunityRulesDemoPage />} />

          {/* ================= APP AVEC LAYOUT ================= */}
          <Route
            path="/*"
            element={
              <MainLayout>
                <Routes>
                  <Route path="/video-mobile-demo" element={<VideoMobileDemoPage />} />
                  <Route path="/video-effects-demo" element={<VideoEffectsDemoPage />} />
                  <Route path="/video-create-demo" element={<VideoCreateDemoPage />} />
                  <Route path="/live-moderation-demo" element={<LiveModerationDemoPage />} />
                  <Route path="/live-gifts-demo" element={<LiveGiftsDemoPage />} />
                  <Route path="/live-fluid-demo" element={<LiveFluidDemoPage />} />
                  <Route path="/live-chat-demo" element={<LiveChatDemoPage />} />
                  <Route path="/security-show" element={<SecurityShowPage />} />
                  <Route path="/coins-show" element={<CoinsShowPage />} />
                  <Route path="/lives-show" element={<LivesShowPage />} />
                  <Route path="/video-shorts" element={<VideoShortsPage />} />
                  <Route path="/" element={<Home />} />
                  <Route path="/lives" element={<LivesShowPage />} />
                  <Route path="/feed" element={<TikTokFeed />} />
                  <Route path="/videos" element={<Feed />} />
                  <Route path="/video/:id" element={<VideoById />} />
                  <Route path="/watch/:id" element={<VideoPage />} />
                  <Route path="/live" element={<LivePage />} />

                  <Route
                    path="/cadeaux-recus"
                    element={
                      isLogged ? <CadeauxRecusPage /> : <Navigate to="/login" replace />
                    }
                  />

                  <Route
                    path="/friends"
                    element={
                      isLogged ? <FriendsPage /> : <Navigate to="/login" replace />
                    }
                  />

                  <Route path="/create-video" element={<CreatePage />} />

                  <Route
                    path="/login"
                    element={
                      isLogged ? <Navigate to="/" replace /> : <Login />
                    }
                  />

                  <Route
                    path="/register"
                    element={
                      isLogged ? <Navigate to="/" replace /> : <Register />
                    }
                  />

                  <Route
                    path="/safe"
                    element={
                      isLogged ? <Safe /> : <Navigate to="/login" replace />
                    }
                  />

                  <Route
                    path="/upload"
                    element={
                      isLogged ? <UploadTabs /> : <Navigate to="/login" replace />
                    }
                  />

                  <Route
                    path="/packs"
                    element={
                      isLogged ? <PacksPage /> : <Navigate to="/login" replace />
                    }
                  />

                  <Route
                    path="/coffre"
                    element={
                      isLogged ? <CoffreDashboard /> : <Navigate to="/login" replace />
                    }
                  />

                  <Route
                    path="/retrait"
                    element={
                      isLogged ? <Retrait /> : <Navigate to="/login" replace />
                    }
                  />

                  <Route
                    path="/retrait/cadeaux"
                    element={
                      isLogged ? <RetraitCadeaux /> : <Navigate to="/login" replace />
                    }
                  />

                  <Route
                    path="/retrait/euros/confirmation"
                    element={
                      isLogged ? (
                        <WithdrawEurosConfirm />
                      ) : (
                        <Navigate to="/login" replace />
                      )
                    }
                  />

                  <Route
                    path="/retrait/euros"
                    element={
                      isLogged ? <WithdrawEuros /> : <Navigate to="/login" replace />
                    }
                  />

                  <Route
                    path="/solde"
                    element={
                      isLogged ? <SoldePage /> : <Navigate to="/login" replace />
                    }
                  />

                  <Route
                    path="/retrait/coins/confirmation"
                    element={<WithdrawCoinsConfirm />}
                  />

                  <Route
                    path="/cadeaux"
                    element={
                      isLogged ? <GiftPage /> : <Navigate to="/login" replace />
                    }
                  />

                  <Route path="/user/:pseudo" element={<UserProfile />} />
                  <Route path="/music" element={<MusicPage />} />

                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </MainLayout>
            }
          />
        </Routes>

        <MiniPlayer />

        <GiftAnimation />
      </Router>
    </AudioProvider>
  );
}

export default App;